import React from 'react';
import cx from 'classnames';
var css = {
  "row": "oalp-3KCKR",
  "column": "oalp-kbsMU",
  "container": "oalp-3zRMP",
  "title": "oalp-mAJIm",
  "subtitle": "oalp-2KgoW"
};
import ImageWrapper from "../../Components/ImageWrapper/ImageWrapper";
import CTA from "../../Components/CTA/CTA";
import TitleComponent from "../../Components/Title/Title";
import ReactMarkdown from 'react-markdown';
var emptyObj = {};
var EqualSpacedStaticContent = function EqualSpacedStaticContent(_ref) {
  var name = _ref.name,
    data = _ref.data,
    metadata = _ref.metadata,
    track = _ref.track;
  var _ref2 = metadata || {},
    _ref2$style = _ref2.style,
    widgetStyle = _ref2$style === void 0 ? emptyObj : _ref2$style,
    _ref2$alignment = _ref2.alignment,
    alignment = _ref2$alignment === void 0 ? 'row' : _ref2$alignment;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(css.container, css[alignment]),
    style: widgetStyle
  }, data.map(function (item, index) {
    var image = item.image,
      title = item.title,
      subtitle = item.subtitle,
      cta = item.cta,
      _item$itemAlignment = item.itemAlignment,
      itemAlignment = _item$itemAlignment === void 0 ? 'column' : _item$itemAlignment,
      itemStyle = item.itemStyle;
    return /*#__PURE__*/React.createElement("div", {
      key: "".concat(alignment, "_").concat(index),
      className: css[itemAlignment],
      style: itemStyle
    }, image && /*#__PURE__*/React.createElement(ImageWrapper, {
      image: image
    }), title && /*#__PURE__*/React.createElement(TitleComponent, {
      title: title,
      className: css.title
    }), subtitle && /*#__PURE__*/React.createElement("div", {
      className: css.subtitle,
      style: subtitle.style
    }, /*#__PURE__*/React.createElement(ReactMarkdown, {
      linkTarget: "_blank"
    }, subtitle.text)), cta && cta.buttons && cta.buttons.map(function (btn, idx) {
      return /*#__PURE__*/React.createElement(CTA, {
        key: idx,
        metadata: metadata,
        widgetKey: name,
        button: btn,
        track: track
      });
    }));
  }));
};
export default EqualSpacedStaticContent;